var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"delete",on:{"click":_vm.deleteCity}})
}
var staticRenderFns = []

export { render, staticRenderFns }